import type {AssigneePickerBaseAssignee, AssigneePickerBaseProps} from '@github-ui/item-picker-assignee'
import {
  AssigneePicker as AssigneePickerTsq,
  type AssigneePickerProps as AssigneePickerTsqProps,
  AssigneeRepositoryPicker as AssigneeRepositoryPickerTsq,
} from '@github-ui/item-picker-assignee-tsq'

import {useViewer} from './hooks/useViewer'

/**
 * @deprecated use '@github-ui/item-picker-assignee-tsq' instead
 */
export type AssigneePickerAssignee = AssigneePickerBaseAssignee & {
  type?: string
}

/**
 * @deprecated use '@github-ui/item-picker-assignee-tsq' instead
 */
export type AssigneePickerProps = AssigneePickerBaseProps &
  Pick<AssigneePickerTsqProps, 'metricsSurface'> & {
    repo: string
    owner: string
  }

/**
 * @deprecated use '@github-ui/item-picker-assignee-tsq' instead
 */
export type AssigneeIssuePickerProps = AssigneePickerProps & {
  number: number
}

/**
 * @deprecated use '@github-ui/item-picker-assignee-tsq' instead
 */
export type AssigneeRepositoryPickerProps = AssigneePickerProps & {
  assigneeTokens: string[]
  includeAssignableBots: boolean
  includeAuthorableBots: boolean
}

/**
 * @deprecated use '@github-ui/item-picker-assignee-tsq' instead
 */
export function AssigneePicker(props: AssigneeIssuePickerProps) {
  const viewer = useViewer()
  return <AssigneePickerTsq {...props} viewer={viewer} />
}

/**
 * @deprecated use '@github-ui/item-picker-assignee-tsq' instead
 */
export function AssigneeRepositoryPicker(props: AssigneeRepositoryPickerProps) {
  const viewer = useViewer()
  return <AssigneeRepositoryPickerTsq {...props} viewer={viewer} />
}
